import React from "react";
import { CustomButton } from "../../../../components/Button/Button";
import { currentUserId } from "../../../../utils/constants";

const WorklogActions = ({ data, handleEdit, handleDelete, boardPermission }) => (

  <div className="d-flex reset-btn">
    {data?.user_id == currentUserId() && (
      <>
        {boardPermission?.can_edit_work_log && (
        <CustomButton
          className="worklog-box-btn1 reset-btn"
          onClick={handleEdit}>
          Edit
        </CustomButton>
        )}
        {boardPermission?.can_delete_work_log && (
        <CustomButton
          onClick={handleDelete}
          className="worklog-box-btn2 reset-btn">
          Delete
        </CustomButton>
        )}
      </>
    )}
  </div>
);

export default React.memo(WorklogActions);
